import map_dosha from '../map/map_dosha';
/**
 * トップページ（土砂災害メッシュ）の処理
 */
export default class detail_dosha_map extends map_dosha {
    _onMeshClick;
    /**
     * コンストラクタ
     */
    constructor(mapPos, onMeshClick, containerId) {
        super(containerId, mapPos);
        this.Map.zoomControl.remove();
        this._onMeshClick = onMeshClick;
    }
    /**
     * デフォルト地図レイヤID
     */
    getDefaultLeyerId() {
        return dosya_1kmesh_env.deteil_uinfo_map_id;
    }
    /**
     * メッシュレイヤーの表示
     */
    dispMeshLayer() {
        this.checkUpdateLayer();
    }
    /**
     * 土砂災害メッシュ地図の、メッシュクリック時イベント
     * @param properties
     */
    onMeshClick(properties) {
        if (this._onMeshClick) {
            let meshcode = properties.code;
            this._onMeshClick(meshcode);
        }
    }
}
